import { api_get, api_post } from "../api/utils"

const DeviceAPI = {
    load: _loadDevice,
    list: _loadDeviceList,
    create: _createDevice,
    updateSub: _deviceUpdateSub,
};


async function _loadDevice(key: string) {
    if (!key) {
        return null;
    }
    return api_get("/device/?device=" + key).then((res) => {
        if (!res.ok) {
            return null;
        }
        else {
            return res.json();
        }
    });
}


async function _loadDeviceList(identityKey: string, cursor: string) {
    // Autogenerated
    let url = '/device/list?identity=' + identityKey;
    if (cursor) { url += '&cursor=' + cursor; }
    return api_get(url).then((res) => {
        if (!res.ok) {
            return null;
        }
        else {
            return res.json();
        }
    });
}


async function _createDevice(identityKey: string, name: string) {
    return api_post('/device/create', {name: name, identity: identityKey})
        .then(async (res) => {
            if (res.ok) {
                return await res.json();
            }
        });
}

async function _deviceUpdateSub(identityKey: string,
    deviceKey: string,
    sub: PushSubscriptionJSON) {
        console.log("_deviceUpdateSub: %o", JSON.stringify(sub));
        console.log("deviceKey: %o", deviceKey);
        console.log("identityKey: %o", identityKey);
    return api_post('/device/update-sub', {
        device: deviceKey,
        identity: identityKey,
        sub: sub as JSON})
        .then(async (res) => {
            if (res.ok) {
                return await res.json();
            }
        });
}


export default DeviceAPI;
